module.exports = __webpack_public_path__ + "img/west-2-a-building-photo.9f13c996.jpg";